import React, { useState } from "react"
import {
  Card,
  CardBody,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ReportTable from "components/Common/ReportTable"
import MEReportFilter from "./filter"
import classnames from "classnames"

const MEReportComponent = ({
  data,
  error,
  loading,
  onSearch,
  onChangeRowNumber,
  onExportBtnClick,
  onAdvancedSearchSubmit,
  exportME,
  onPageClick,
  onCategoryChange,
  columns,
  visibleColumns,
  onToggleColumn,
}) => {
  const [filterOpen, setFilterOpen] = useState(false)
  const [activeTab, setActiveTab] = useState("1")

  // Callback function to toggle the advanced search filter visibility
  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  // Toggle between tabs
  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }



  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CustomHeaderTitle
            loading={loading}
            title={""}
            exportBtn={true}
            exportBtnLoading={exportME?.loading}
            onExportBtnClick={onExportBtnClick}
            rowCount={true}
            onChangeRowNumber={onChangeRowNumber}
            searchBox={false}
            rightBtn={false}
            advnacedSearchBtn={true}
            advnacedSearchBtnTitle={"Filter"}
            onAdvancedSearch={onAdvancedSearchHandler}
          />

          <Collapse isOpen={filterOpen}>
            {/* M&E Report Filter Component */}
            <MEReportFilter
              loading={loading}
              onAdvancedSearchSubmit={onAdvancedSearchSubmit}
              onCategoryChange={onCategoryChange}
              columns={columns}
              onToggleColumn={onToggleColumn}
            />
          </Collapse>

          {/* Tabs for Receipts, Distributions, and Balance */}
          <Nav tabs className="mt-3">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => {
                  toggle("1")
                }}
                style={{ cursor: "pointer" }}
              >
                Receipts
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => {
                  toggle("2")
                }}
                style={{ cursor: "pointer" }}
              >
                Distributions
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "3" })}
                onClick={() => {
                  toggle("3")
                }}
                style={{ cursor: "pointer" }}
              >
                Balance
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            {/* Receipts Tab */}
            <TabPane tabId="1">
              <ReportTable
                visibleColumns={visibleColumns}
                data={data?.receipts?.data}
                loading={loading}
                pagination={{ meta: data?.receipts?.meta, onPageClick }}
              />
            </TabPane>

            {/* Distributions Tab */}
            <TabPane tabId="2">
              <GeneralTables
                data={data?.distributions?.data}
                loading={loading}
                headers={[
                  "S.No",
                  "Item ID - Description",
                  "Province",
                  "HMIS Code",
                  "HF Type",
                  "Facility",
                  "Unit Price (UNFPA)",
                  "Unit Price (IP)",
                  "Batch Number",
                  "Expiry Date",
                  "Out Quantity to IP",
                  "Distribution Date",
                ]}
                pagination={{ meta: data?.distributions?.meta, onPageClick: onPageClick }}
                renderItem={(dist, index) => (
                  <tr key={index}>
                    <td style={{ whiteSpace: "nowrap" }}>{data?.distributions?.meta?.from + index}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {dist.item?.unfp_item_name} -{" "}
                      {dist.item?.ip_item_description}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>{dist.province?.province || "N/A"}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{dist.facility?.hmis_code || "-"}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{dist.facility?.facility_type || "-"}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {dist.facility?.facility_name ||
                        dist.other_hfs ||
                        "N/A"}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>{dist.provider_in?.unit_price_per_unfpa || 1}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{dist.provider_in?.unit_price_per_ip || 1}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{dist.provider_in?.batch_number || "N/A"}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {dist.provider_in?.expire_date
                        ? new Date(
                            dist.provider_in.expire_date
                          ).toLocaleDateString("en-GB")
                        : "N/A"}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>{dist.out_quantity}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {new Date(dist.date).toLocaleDateString("en-GB")}
                    </td>
                  </tr>
                )}
              />
            </TabPane>

            {/* Balance Tab */}
            <TabPane tabId="3">
              <GeneralTables
                data={data?.balance?.data}
                loading={loading}
                headers={[
                  "S.No",
                  "Item ID - Description",
                  "Unit Price (UNFPA)",
                  "Unit Price (IP)",
                  "Batch Number",
                  "Expiry Date",
                  "Out Quantity",
                  "Balance",
                ]}
                pagination={{ meta: data?.balance?.meta, onPageClick: onPageClick }}
                renderItem={(balance, index) => (
                  <tr key={index}>
                    <td style={{ whiteSpace: "nowrap" }}>{data?.balance?.meta?.from + index}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{balance.item_description}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{balance.unit_price_unfpa}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{balance.unit_price_ip}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{balance.batch_number}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{balance.expire_date}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{balance.out_quantity}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <strong>{balance.balance}</strong>
                    </td>
                  </tr>
                )}
              />
              
              {/* Total Balance Summary */}
              {data?.balance?.data && data.balance.data.length > 0 && (
                <div className="d-flex justify-content-end mt-3">
                  <div className="bg-light p-3 rounded">
                    <strong>
                      Total Balance: {" "}
                      {data.balance.data.reduce(
                        (sum, b) => sum + (parseFloat(b.balance) || 0),
                        0
                      )}
                    </strong>
                  </div>
                </div>
              )}
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MEReportComponent
